import { defineMessages } from 'react-intl';

export const shipmentSummarySectionMessages = defineMessages({
  sectionTitle: {
    defaultMessage: 'Shipment Summary',
    id: 'RllHuP',
    description: 'Title of the shipment summary card in the freight details view',
  },
  carrierService: {
    defaultMessage: '{carrier} - {service}',
    id: 'jCp1Ai',
    description: 'Carrier name and service level on one line',
  },
  arrives: {
    defaultMessage: 'Arrives {date}',
    id: 'lUKwbo',
    description: 'Estimated delivery date line in the shipment summary',
  },
  costBreakdown: {
    defaultMessage: 'Cost Breakdown',
    id: 'mdrc2b',
    description: 'Accordion toggle label for the cost breakdown section',
  },
  total: {
    defaultMessage: 'Total',
    id: 'wAWRyX',
    description: 'Label for the total cost in the cost breakdown accordion',
  },
  costDisclaimer: {
    defaultMessage: 'Final amount may vary. Post-shipment adjustments are common with LTL.',
    id: 'BpcXEc',
    description: 'Fine print under the freight cost breakdown',
  },
  invoiceCopy: {
    defaultMessage: 'Invoice sent after shipment is delivered.',
    id: '12QXrX',
    description: 'Static copy explaining when the invoice is sent',
  },
  manageBilling: {
    defaultMessage: 'View and manage your billing',
    id: 'WJ3jWF',
    description: 'Link to the billing management page',
  },
  pickupTerminalLabel: {
    defaultMessage: 'Pickup Terminal',
    id: 'WsOQ/B',
    description: 'Label above the origin carrier terminal code in the shipment summary carrier card',
  },
  deliveryTerminalLabel: {
    defaultMessage: 'Delivery Terminal',
    id: 'Dq3Om8',
    description: 'Label above the destination carrier terminal code in the shipment summary carrier card',
  },
});
